<div class="page" >

    <div class="keys" (document:keydown)="onKeydown($event)">
        <div class="key" data-keyCode="KeyA">
            <kbd>A</kbd>
            <span class="sound">clap</span>
        </div>
        <div class="key" data-keyCode="KeyS">
            <kbd>S</kbd>
            <span class="sound">hihat</span>
        </div>
        <div class="key" data-keyCode="KeyD">
            <kbd>D</kbd>
            <span class="sound">kick</span>
        </div>
        <div class="key" data-keyCode="KeyF">
            <kbd>F</kbd>
            <span class="sound">openhat</span>
        </div>
        <div class="key" data-keyCode="KeyG">
            <kbd>G</kbd>
            <span class="sound">boom</span>
        </div>
        <div class="key" data-keyCode="KeyH">
            <kbd>H</kbd>
            <span class="sound">ride</span>
        </div>
        <div class="key" data-keyCode="KeyJ">
            <kbd>J</kbd>
            <span class="sound">snare</span>
        </div>
        <div class="key" data-keyCode="KeyK">
            <kbd>K</kbd>
            <span class="sound">tom</span>
        </div>
        <div class="key" data-keyCode="KeyL">
            <kbd>L</kbd>
            <span class="sound">tink</span>
        </div>
    </div>

    <audio data-keyCode="KeyA" src="../assets/sounds/clap.wav"></audio>
    <audio data-keyCode="KeyS" src="../assets/sounds/hihat.wav"></audio>
    <audio data-keyCode="KeyD" src="../assets/sounds/kick.wav"></audio>
    <audio data-keyCode="KeyF" src="../assets/sounds/openhat.wav"></audio>
    <audio data-keyCode="KeyG" src="../assets/sounds/boom.wav"></audio>
    <audio data-keyCode="KeyH" src="../assets/sounds/ride.wav"></audio>
    <audio data-keyCode="KeyJ" src="../assets/sounds/tom.wav"></audio>
    <audio data-keyCode="KeyK" src="../assets/sounds/snare.wav"></audio>
    <audio data-keyCode="KeyL" src="../assets/sounds/tink.wav"></audio>
  
</div>
